import { SystemDescriptions } from "src/common/descriptions";
import { searchableTableUtils } from "src/components/SearchableTable/utils";

const descriptions = SystemDescriptions.PAGES.SERVICE.SERVICE_CATEGORIES
const commonDescriptions = SystemDescriptions.PAGES.COMMON

export enum ColumnsKeys {
    NO = 'key',
    NAME = 'name',
    IS_ACTIVE = 'isActive',
    ACTIONS = 'ACTIONS',
}

export const TABLE_COLUMNS: any = [
    {
        title: descriptions.TABLE_COLUMNS.ID,
        dataIndex: ColumnsKeys.NO,
        key: ColumnsKeys.NO,
        align: searchableTableUtils.alignment.centerAlign,
    },
    {
        title: descriptions.TABLE_COLUMNS.NAME,
        dataIndex: ColumnsKeys.NAME,
        key: ColumnsKeys.NAME,
        align: searchableTableUtils.alignment.centerAlign,
    },
    {
        title: descriptions.TABLE_COLUMNS.STATUS,
        dataIndex: ColumnsKeys.IS_ACTIVE,
        key: ColumnsKeys.IS_ACTIVE,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value) => value === 1 ? commonDescriptions.ACTIVE_STATUS : commonDescriptions.INACTIVE_STATUS
    },
];